export default __webpack_public_path__ + "static/media/weather.f009e441.png";